import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { toAbsoluteUrl } from '../../../../../../../../../Utils/_helpers'
import Checkbox from '../checkbox'
import RadioButton from '../radio'

class NodeLabel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    actions: PropTypes.array,
    title: PropTypes.string,
    sub_title: PropTypes.string,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    partial: PropTypes.bool,
    disabled: PropTypes.bool,
    dataset: PropTypes.object,
    mode: PropTypes.oneOf(['multiSelect', 'simpleSelect', 'radioSelect', 'hierarchical']),
    showPartiallySelected: PropTypes.bool,
    onCheckboxChange: PropTypes.func,
    readOnly: PropTypes.bool,
    clientId: PropTypes.string,
  }

  handleCheckboxChange = e => {
    const { mode, id, onCheckboxChange } = this.props

    if (mode === 'simpleSelect' || mode === 'radioSelect') {
      onCheckboxChange(id, true)
    } else {
      const {
        target: { checked },
      } = e
      onCheckboxChange(id, checked)
    }
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
  }

  onToggle = e => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if(this.props.onNodeToggle)
    this.props.onNodeToggle(this.props.id)
  }

  render() {
    const { mode, title, label, id, partial, checked, viewMode,type } = this.props
    const { value, disabled, showPartiallySelected, readOnly, clientId ,expanded} = this.props
    const nodeLabelProps = { className: 'node-label' }

    // in case of simple select mode, there is no checkbox, so we need to handle the click via the node label
    // but not if the control is in readOnly or disabled state
    const shouldRegisterClickHandler = mode === 'simpleSelect' && !readOnly && !disabled

    if (shouldRegisterClickHandler) {
      nodeLabelProps.onClick = this.handleCheckboxChange
    }

    const sharedProps = { id, value, checked, disabled, readOnly, tabIndex: -1 }
    const className = ['checkbox-item', mode === 'simpleSelect' && 'simple-select'].filter(Boolean).join(' ')
    
    
    if(viewMode == 'full-mode'){

      return (
        <div title={title || label} htmlFor={id} className="node-title-label">
          
          {type!='plan' && <>{mode === 'radioSelect' ? (
            <RadioButton name={clientId} className="radio-item" onChange={this.handleCheckboxChange} {...sharedProps} />
          ) : (
            <Checkbox
              name={id}
              className={className}
              indeterminate={showPartiallySelected && partial}
              onChange={this.handleCheckboxChange}
              {...sharedProps}
            />
          )}</>}
          <span {...nodeLabelProps}>{label}</span>
          {type =='plan' && <span style={{float:'right',position:'relative'}}>
          {!expanded && <div className="down-arrowdd">
            <a href="#" onClick={this.onToggle}>
               <img src={toAbsoluteUrl("/media/sr/icons/filter-down.svg")} /></a>
          </div>}
          {expanded && <div className="up-arrowdd">
          <a href="#" onClick={this.onToggle}>
            <img src={toAbsoluteUrl("/media/sr/icons/filter-up.svg")} /></a>
          </div>}</span>}
          
        </div>
      )

    }
    return (
      <label title={title || label} htmlFor={id}>
        {mode === "radioSelect" ? (
          <RadioButton
            name={clientId}
            className="radio-item"
            onChange={this.handleCheckboxChange}
            {...sharedProps}
          />
        ) : (
          <Checkbox
            name={id}
            className={className}
            indeterminate={showPartiallySelected && partial}
            onChange={this.handleCheckboxChange}
            {...sharedProps}
          />
        )}
        <span>
          <span
            style={{ fontWeight: this.props.type === "grouping" && "500" }}
            {...nodeLabelProps}
          >
            {label}
          </span>
          {this.props.sub_title && (
            <span
              style={{ fontSize: "0.7rem" }}
              className="text-muted badge badge-light wrap-expired-label"
            >
              Expired on: {this.props.sub_title}
            </span>
          )}
        </span>
      </label>
    );
  }
}

export default NodeLabel
